import styled from 'styled-components';
// import theme from '../theme';

const FactorIconStyles = styled.svg`
  width: 100%;
  height: auto;
`;

export default FactorIconStyles;
